export enum AuthStateEnum {
  signIn = 'signIn',
  signedIn = 'signedIn',
  signedOut = 'signedOut',
  loading = 'loading',
  error = 'error',
  signUp = 'signUp',
  createCompany = 'createCompany',
}
